import SvgImageIcon from "@Components/CustomIcon/ImageIcon"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { canGotoNextAtom, surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import React, { useEffect, useState } from "react"
import { Platform, StyleSheet, View } from "react-native"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import * as DocumentPicker from "expo-document-picker"
import { TouchableOpacity } from "react-native"
import { cacheDirectory, copyAsync, getInfoAsync, makeDirectoryAsync } from "expo-file-system"
import * as MediaLibrary from "expo-media-library"
import { ParentSurveyContent } from "./ParentSurveyContent"
import { SALUTANCE } from "@Services/AxiosInstance"
import { Button } from "react-native"

export function isLessThanTheMB(fileSize, smallerThanSizeMB) {
    const isOk = fileSize / 1024 / 1024 < smallerThanSizeMB
    return isOk
}

const allowedTypes = ["application/pdf", "image/png", "image/jpeg"]

export const QuestionWithMedia = (props) => {
    const { axisId, surveyId, responseTypeId, hasPrecision, userResponse, isParent } = props
    const [permissionResponse, requestPermission] = MediaLibrary.usePermissions()
    const setCanGoToNext = useSetRecoilState(canGotoNextAtom)
    const [file, setFile] = useState(null)
    const [fileName, setFileName] = useState(null)

    const getFileInfo = async (fileURI) => {
        const fileInfo = await getInfoAsync(fileURI)
        return fileInfo
    }

    const createCacheFile = async ({ name, uri }) => {
        if (!(await getInfoAsync(cacheDirectory + "uploads/")).exists) {
            await makeDirectoryAsync(cacheDirectory + "uploads/")
        }
        const cacheFilePath = cacheDirectory + "uploads/" + name
        await copyAsync({ from: uri, to: cacheFilePath })
        return cacheFilePath
    }

    const _pickDocument = async () => {
        if (!permissionResponse.granted) {
            const result = await requestPermission()
            if (!result.granted) {
                alert("Veullez autoriser l'application à acceder au stockage de l'appareil .")
                return
            }
        }

        let documentPicked = await DocumentPicker.getDocumentAsync({
            copyToCacheDirectory: false,
            type: allowedTypes
        })

        if (!allowedTypes.includes(documentPicked.mimeType)) {
            alert("Type de fichier non prise en compte")
            return
        }

        const fileInfo = await getFileInfo(documentPicked.uri)
        const isLt5MB = isLessThanTheMB(fileInfo.size, 5)
        if (!isLt5MB) {
            alert(`La taille du fichier ne doit pas dépasser 5 Mo !`)

             // Réinitialisation des champs de fichier si la taille dépasse 5 Mo
            setFile(null)  // Réinitialiser l'état du fichier
            setFileName(null)  // Réinitialiser le nom du fichier
            return
        }

        const cacheOptions = { name: documentPicked.name, uri: documentPicked.uri }
        const file = await createCacheFile(cacheOptions)

        let base64Content = ""
        const mimeType = documentPicked?.mimeType ?? "image/jpeg"

        if (base64Content) {
            const base64File = `data:${mimeType};base64,${base64Content}`
            setResponse((old) => ({
                ...old,
                responseTypeId: 4,
                filecontent: base64File
            }))
            setResponseGlobal((old) => ({
                ...old,
                [surveyId]: {
                    ...response,
                    responseTypeId: 4,
                    filecontent: base64File,
                    filename: documentPicked.name
                }
            }))
            setFile({ name: documentPicked.name })
            setFileName(documentPicked.name) // Mettre à jour le nom du fichier
        }
    }

    const defaultResponse = {
        axisId: axisId,
        surveyId: surveyId,
        responseTypeId: responseTypeId,
        responseValue: "",
        hasPrecision: hasPrecision,
        precisionAnswer: "",
        filecontent: ""
    }

    const [response, setResponse] = useState(defaultResponse)
    const [responseGlobal, setResponseGlobal] = useRecoilState(surveyResponsesAtom)
    const [sliderValue, setSliderValue] = useState(response.responseValue)
    const [precision, setPrecision] = useState("")
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)

    useEffect(() => {
        if (responseGlobal[response?.surveyId]) {
            setResponse({ ...responseGlobal[response?.surveyId] })
        } else {
            setResponseGlobal((old) => ({
                ...old,
                [surveyId]: {
                    ...response
                }
            }))
        }
    }, [responseGlobal])

    useEffect(() => {
        if (userResponse?.id > 0 && currentEducationalDiagnosis?.id > 0) {
            setSliderValue(+userResponse?.response)
            setPrecision(userResponse?.precision)
        }
    }, [userResponse])

    useEffect(() => {
        setCanGoToNext(true)
    }, [])

    useEffect(() => {
        if (responseGlobal[surveyId]?.surveyId) {
            setFile({ name: responseGlobal[surveyId].filename })
        }
    }, [])

    const handleFileUpload = (event) => {
        const fileData = event.target.files[0]
        const fileName = fileData?.name ?? ""
        setFileName(fileName)

        if (fileData) {
            const fileSizeInMB = fileData.size / 1024 / 1024
            if (fileSizeInMB > 5) {
                alert("La taille du fichier ne doit pas dépasser 5 Mo !")
                
                // Réinitialiser les états de fichier et du nom du fichier si le fichier est trop grand
                setFile(null);  // Réinitialiser l'état du fichier
                setFileName(null);  // Réinitialiser le nom du fichier
                return;  // Ne pas continuer si le fichier est trop volumineux
            }

            const reader = new FileReader()
            reader.readAsDataURL(fileData) // Convert file to Base64
            reader.onload = () => {
                const base64File = reader?.result
                if (base64File) {
                    setResponse((old) => ({
                        ...old,
                        responseTypeId: 4,
                        filecontent: base64File
                    }))
                    setResponseGlobal((old) => ({
                        ...old,
                        [surveyId]: {
                            ...response,
                            responseTypeId: 4,
                            filecontent: base64File,
                            filename: fileName
                        }
                    }))
                }
            }
            reader.onerror = (error) => {
                console.error("Erreur lors de la lecture du fichier :", error)
            }
        }
    }

    if (isParent) {
        return <ParentSurveyContent question={question} />
    }

    return (
        <View style={{ padding: 20 }}>
            <OpenSansText color={props.color}>
                {SALUTANCE ? "QUESTION : " : !props.isChildren ? `QUESTION N° ${props.questionNumber}` : ""}
            </OpenSansText>
            <Spacer height={10} />
            <OpenSansText fontSize={14}>{props.question}</OpenSansText>
            <Spacer height={20} />

            {Platform.OS === "web" ? (
                <>
                    <input
                        type="file"
                        id="fileInput"
                        onChange={handleFileUpload}
                        style={{ display: "none" }} // Hide input
                    />

                    <label htmlFor="fileInput">
                        <TouchableOpacity>
                            <View style={styles.containerOfImage}>
                                <View
                                    style={{
                                        justifyContent: "center",
                                        width: "100%",
                                        alignItems: "center",
                                        alignContent: "center"
                                    }}
                                >
                                    <SvgImageIcon width={40} height={50} />
                                </View>
                                <Spacer height={15} />

                                <OpenSansText textAlign="center" fontSize={14}>
                                    {`Cliquez pour ${file?.content ? "modifier le" : "ajouter un"}  fichier`}
                                </OpenSansText>
                                {fileName && (
                                    <OpenSansText fontStyle={"Regular"} textAlign="center" fontSize={14}>
                                        {`Fichier sélectionné : `}
                                        <OpenSansText
                                            fontStyle={"Bold"}
                                            textAlign="center"
                                            fontSize={14}
                                        >{`${fileName}`}</OpenSansText>
                                    </OpenSansText>
                                )}
                                <Spacer height={10} />
                                <OpenSansText fontStyle={"Regular"} textAlign="center" fontSize={14}>
                                    Les fichiers ne peuvent pas dépasser 5Mo.
                                </OpenSansText>
                            </View>
                        </TouchableOpacity>
                    </label>
                </>
            ) : (
                <TouchableOpacity onPress={() => _pickDocument()}>
                    <View style={styles.containerOfImage}>
                        <View
                            style={{
                                justifyContent: "center",
                                width: "100%",
                                alignItems: "center",
                                alignContent: "center"
                            }}
                        >
                            <SvgImageIcon width={40} height={50} />
                        </View>
                        <Spacer height={15} />

                        <OpenSansText textAlign="center" fontSize={14}>
                            {`Cliquez pour ${file?.content ? "modifier le" : "ajouter un"}  fichier`}
                        </OpenSansText>
                        {file && file?.name && (
                            <OpenSansText fontStyle={"Regular"} textAlign="center" fontSize={14}>
                                {`Fichier sélectionné : `}
                                <OpenSansText
                                    fontStyle={"Bold"}
                                    textAlign="center"
                                    fontSize={14}
                                >{`${file?.name}`}</OpenSansText>
                            </OpenSansText>
                        )}
                        <Spacer height={10} />
                        <OpenSansText fontStyle={"Regular"} textAlign="center" fontSize={14}>
                            Les fichiers ne peuvent pas dépasser 5Mo.
                        </OpenSansText>
                    </View>
                </TouchableOpacity>
            )}
            <Spacer height={20} />
        </View>
    )
}

const styles = StyleSheet.create({
    containerOfImage: {
        paddingTop: 30,
        borderRadius: 10,
        paddingBottom: 20,
        width: "100%",
        borderStyle: "dashed",
        borderWidth: 1,
        borderColor: baseColors.green.dark
    },
    uploadInfo: {
        padding: 20,
        backgroundColor: baseColors.green.light,
        borderRadius: 10,
        height: 89,
        width: "100%"
    },
    progress: { height: 5, borderRadius: 10, backgroundColor: baseColors.grey }
})